import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MultiprojectManagerComponent } from './multiproject-manager/multiproject-manager.component';
import { FunctionalAssignmentComponent } from './functional-assignment/functional-assignment.component';
import { MaintenanceExpansionConfigComponent } from './maintenance-expansion-config/maintenance-expansion-config.component';
import { RecentProjectsTrackerComponent } from './recent-projects-tracker/recent-projects-tracker.component';

@Component({
  selector: 'app-inco-admin',
  standalone: true,
  imports: [
    MatTabsModule,
    MultiprojectManagerComponent,
    FunctionalAssignmentComponent,
    MaintenanceExpansionConfigComponent,
    RecentProjectsTrackerComponent
  ],
  templateUrl: './inco-admin.component.html',
  styleUrls: ['./inco-admin.component.less'],
})
export class IncoAdminComponent{
  title: string = `INCO: Admin`;
  
  constructor() { }
}